import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  showCountries: true,
  stayInLocationVariant: 'secondary'
} satisfies RecursivePartial<DialogConfig['locationConfirmation']>
